import * as copy from 'copy-to-clipboard'

export default copy
